import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  TextField,
  InputAdornment,
  Typography,
  MenuItem,
  Button,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import DateRangePicker from './components/DateRangePicker/DateRangePicker';
import TimeRangePicker from './components/TimeRangePicker/TimeRangePicker';
import { PlaybackSpeeds } from './components/PlaybackBar/PlaybackBar';

import './components/common.scss';
import './CsrmPage.scss';

export default function CsrmPage() {
  const [subjectId, setSubjectId] = useState('');
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startTime, setStartTime] = useState(new Date());
  const [endTime, setEndTime] = useState(new Date());
  const [playbackSpeed, setPlaybackSpeed] = useState(PlaybackSpeeds[0].value);

  return (
    <div className="csrm-container">
      <div className="header-container">
        <h1>Crew State and Risk Model</h1>
      </div>
      <div className="setup-controls">
        <div className="control-row">
          <Typography variant="h6" component="h6" sx={{ mb: 2 }}>
            Setup
          </Typography>
        </div>
        <div className="control-row" style={{ padding: 0 }}>
          <TextField
            label="Subject ID"
            id="csrm-subject-id"
            sx={{ width: '60ch' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">H3PO</InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear subject ID"
                    onClick={() => setSubjectId('')}
                    edge="end"
                  >
                    {subjectId ? <Close /> : ''}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={subjectId}
            onChange={(e) => setSubjectId(e.target?.value)}
            variant="outlined"
            margin="dense"
          />
        </div>
        <div className="control-row">
          You can find the Subject ID by lorem ipsum dolor sit amet, consectetur
          adipiscing elit. Quisque nisl eros, pulvinar facilisis justo mollis,
          auctor consequat urna.
        </div>
        <div className="control-row">
          <DateRangePicker
            dateRange={dateRange}
            onDateRangeChange={setDateRange}
            showOutline
            showLabels
          />
        </div>
        <div className="control-row">
          <TimeRangePicker
            startTime={startTime}
            endTime={endTime}
            onStartTimeChange={setStartTime}
            onEndTimeChange={setEndTime}
            showOutline
            showLabels
          />
        </div>
        <div className="control-row" style={{ justifyContent: 'unset' }}>
          <div className="responsive-fill" />
          <TextField
            id="playback-speed"
            select
            label="Play Speed"
            value={playbackSpeed}
            onChange={(e) => setPlaybackSpeed(e.target?.value)}
            sx={{ width: '8ch' }}
            variant="standard"
          >
            {PlaybackSpeeds.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className="control-row">
          <Link
            to={{
              pathname: '/csrm/charts',
              state: {
                dateRange,
                startTime,
                endTime,
                subjectId,
                playbackSpeed,
              },
            }}
          >
            <Button variant="contained" size="large" sx={{ width: '60ch' }}>
              Start
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
